<template>
  <section class="content">
    <!-- <div class="box box-info"> -->
    <form>
      <website ref="website"/>
      <div class="name">
        <div class="page section-header text-center">
          <h1 class="h1">Your Cart</h1>
        </div>
        <div class="page-width">
          <div class="rte"></div>
          <div class="page-width">

            <DataTable ref="dt" :value="products" dataKey="id"
                       :paginator="true" :rows="10" :filters="filters"
                       paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                       :rowsPerPageOptions="[5,10,25]"
                       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products">
              <Column header="Image">
                <template #body="slotProps">
                  <img :src="'demo/images/product/' + slotProps.data.image" :alt="slotProps.data.image"
                       class="product-image"/>
                </template>
              </Column>
              <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
              <Column field="code" header="Product" sortable></Column>
              <Column field="name" header="Price" sortable></Column>

              <Column field="price" header="Price" sortable>
              </Column>
              <Column field="category" header="Quantity" sortable></Column>
              <Column field="rating" header="Total" sortable>
              </Column>

              <Column>
                <template #body="slotProps">
                  <Button icon="pi pi-pencil" class="p-button-success p-mr-2"
                          @click="editProduct(slotProps.data)"/>
                  <Button icon="pi pi-trash" class="p-button-warning"
                          @click="confirmDeleteProduct(slotProps.data)"/>
                </template>
              </Column>
            </DataTable>

            <footer class="cart__footer">

              <div class="col-sm-8">
                <!-- <div class="grid__item medium-up--two-thirds cart-note pull-right"> -->
                <div class="solid-border">
                  <h5>
                    <label class="cart-note__label small--text-center">
                      Add a note to your order
                    </label>
                    <Textarea v-model="value" rows="8" cols="60"/>

                  </h5>
                </div>
                <!-- </div> -->
              </div>
              <div class="col-sm-4">
                <div class="grid">


                  <div class="solid-border">
                    <div class="grid">
            <span class="grid__item one-half cart__subtotal-title">
SUBTOTAL
            </span>
                      <span class="grid__item one-half cart__subtotal text-right">
                {{ 333333 }}
            </span>
                    </div>
                    <div class="cart__shipping">
                      Shipping & taxes calculated at checkout
                    </div>
                    <Button @click="$router.push('cart')" label="CHECKOUT" style="border: 0px solid #eceff1;"
                            class="btn btn--small-wide checkout">


                    </Button>

                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </footer>

          </div>

        </div>
      </div>
      <footerWebsite ref="footerWebsite"/>
    </form>
    <!-- </div> -->
  </section>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Textarea from 'primevue/textarea'

export default {
  name: 'aboutUs',
  props: ['aboutUs'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
        {label: 'Price High to Low', value: '!price'},
        {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {},
  mounted() {
  },
  methods: {},
  components: {
    Button,
    InputText,
    Column,
    DataTable,
    website,
    footerWebsite,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/website.css">
</style>



// WEBPACK FOOTER //
// cart.vue?94dc16bc